(function () {
  // Keep autoplay reliable on iOS and pause when off-screen
  const root = document.currentScript && document.currentScript.closest
    ? document.currentScript.closest('.atd-hero-1')
    : document.querySelector('.atd-hero-1');

  if (!root) return;

  const video = root.querySelector('.atd-hero-1__video');
  if (!video) return;

  // iOS Safari requires these set as DOM properties, not just HTML attributes
  video.muted = true;
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');

  // Try play on load (muted + playsinline)
  const tryPlay = () => {
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  if (video.readyState >= 2) tryPlay();
  else video.addEventListener('canplay', tryPlay, { once: true });

  // Pause when scrolled off screen
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) tryPlay();
        else video.pause();
      });
    },
    { threshold: 0.2 }
  );
  io.observe(video);
})();
